<div class="wrapper">
    <div class="formwrap py-5">
      <div class="titlewrap container">
        <h1 class="title text-center">Add / Update Fees</h1>
            <div class="card mt-4">
              <div class="card-body">
                <!-- <h2>Welcome to Migration certificate issuance: Portal!!</h2> -->
                <form class="row g-3">
                  <div class="col-md-12 ">
                    <div class="row">
                        <div class="col-md-5 text-end">
                          <label for="validationDefault04" class="form-label ">Select Application Type</label>
                        </div>
                        <div class="col-md-4">
                          <select class="form-select" id="validationDefault04" required (change)="getselectedappdetail($event.target)">
                              <option selected disabled value="">Choose...</option>
                              <option *ngFor="let fees of allfeesdata" [value]="fees.application_type">{{fees.application_type_name}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                 
                  <div class="col-md-4">
                    <label for="validationDefault01" class="form-label">Application Name<span class="strip">*</span></label>
                    <input type="text" class="form-control"  [attr.disabled]="formdisable" [value]="selectedappname">
                  </div>
                  <div class="col-md-4">
                    <label for="validationDefault02" class="form-label">Basic Fees</label>
                    <input type="number" class="form-control"  [attr.disabled]="formdisable" [value]="selectedappbasic">
                  </div>
                  <div class="col-md-4">
                    <label for="validationDefaultUsername" class="form-label">Postal fees</label>
                    <div class="input-group">
                      <input type="number" class="form-control"  [attr.disabled]="formdisable" [value]="selectedappextra">
                    </div>
                  </div>                 
                  <div class="col-md-12 text-center">
                    <button class="btn btn-primary invisible" data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="actiontaking('Add')">Add New</button>
                  <!-- </div>
                  <div class="col-4 text-center">   -->
                    <button class="btn btn-primary mx-3" [attr.disabled]="addeditmodal?true:null" data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="actiontaking('Update')">Edit</button>
                  <!-- </div>
                  <div class="col-4 text-center">   -->
                    <button class="btn btn-primary invisible" [attr.disabled]="addeditmodal?true:null" (click)="deletfeesdetails()">Delete</button>
                  </div>
                </form>
              </div>
            </div> 
              <!-- modal for add edit  -->
            <div class="modal fade pt-5" data-bs-backdrop="static" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header ">
                    <h5 class="modal-title" id="exampleModalLabel">{{actiontaken}} Application Fees</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                  <form class="row" method="post" role="form" #form="ngForm" [formGroup]="feesform" (ngSubmit)="onSubmit(feesform.value)">
                    <div class="col-md-12">
                          <label for="validationDefault01" class="form-label">Application Name<span class="strip">*</span></label>
                          <input type="text" class="form-control" formControlName="applicationname"  name="applicationname"
                           [ngClass]="{ 'is-invalid': submitted && f.applicationname.errors }" [attr.disabled]="true">
                           <div *ngIf="submitted && f.applicationname.errors" class="invalid-feedback">
                              <div *ngIf="f.applicationname.errors.required">Application Name is required</div>
                          </div>
                    </div>                      
                    <div class="col-md-6">
                      <label for="validationDefault02" class="form-label">Basic Fees</label>
                      <input type="number" class="form-control" formControlName="applicationbasic"  name="applicationbasic"
                           [ngClass]="{ 'is-invalid': submitted && f.applicationbasic.errors }">
                           <div *ngIf="submitted && f.applicationbasic.errors" class="invalid-feedback">
                            <div *ngIf="f.applicationbasic.errors.required">Basic Fees is required</div>
                          </div>     
                    </div>
                    <div class="col-md-6">
                      <label for="validationDefaultUsername" class="form-label">Postal fees</label>
                      <div class="input-group">
                        <input type="number" class="form-control" formControlName="applicationextra"  name="applicationextra"
                        [ngClass]="{ 'is-invalid': submitted && f.applicationextra.errors }">
                        <div *ngIf="submitted && f.applicationextra.errors" class="invalid-feedback">
                          <div *ngIf="f.applicationextra.errors.required">Postal fees is required</div>
                        </div>
                      </div>
                    </div>                 
                    <div class="modal-footer">
                      <button class="btn btn-primary" type="submit">{{actiontaken}}</button>
                    </div>
                  </form>
                  </div>
                </div>
              </div>
            </div>  
      </div>
    </div>
</div>
    
